<template>
  <div>
    <div>
      <div v-if="isDropdown" class="switchDiv" ref="dropdownMenu">
        <div v-for="item in sideMenus" style=" display: flex; align-items: center; margin-left: -2em">
          <span style="color: #000000; margin-left: 4em;
    margin-top: 1em;" @click.prevent="switchingSidebar(item.id, item.url)">
            <img style="width: 24px" :src="item.img" alt="menu logo" />
            <p style="display: inline-block; margin-left: 1em;">{{ item.title }}</p>
          </span>
        </div>
      </div>
    </div>
    <div class="toggleDiv toggleDivExpand" v-if="toggleExpand">
      <span class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"
          @click="toggleSidebar()"><img :src="sidebarIcon" alt="sidebar icon"></a></span>
    </div>
    <div class="toggleDiv toggleDivShrink" v-else>
      <span class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"
          @click="toggleSidebar()"><img :src="sidebarReverseIcon" alt="side bar reverse icon"></a></span>
    </div>
    <div class="main-menu menu-fixed menu-light  menu-shadow" id="sidehover" data-scroll-to-active="true">
      <div class="navbar-header" ref="navbarHeader">
        <ul class="nav navbar-nav flex-row">
          <li class="nav-item mr-auto"><a class="navbar-brand">
              <div class="brand-logo">
                <img v-if="toggleExpand" class="logo" src="@/assets/pacto-clo-logo.svg" alt="pacto logo" @focus="dropdownEnable"
                  tabindex="0" />
                <img v-else class="iconStyle" src="@/assets/Rectangle.svg" alt="rectangle image" />
              </div>
            </a></li>
        </ul>
      </div>
      <div class="shadow-bottom"></div>
      <div class="main-menu-content">
        <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation"
          data-icon-style="lines" v-if="selectedMenu == 'pacto'">
          <li class="nav-item nav-item-sidebar" id="nav-item-sidebar-profile">
            <router-link :to="{ name: 'DashboardPage' }">
              <em data-icon="user" style="visibility: hidden;"></em><span class="menu-title" data-i18n="Profile">{{
                $t('sidebar_module_pact_menu_item_pacto_dashboard')
              }}</span>
            </router-link>
          </li>
        </ul>
        <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation"
          data-icon-style="lines" v-for="(sidebar, menuIndex) in sidebarArray">
          <li class="navigation-header  headingStyle "><span class="wordStyle titleStyle">{{ $t(sidebar.title) }}</span>
          </li>
          <li class="nav-item nav-item-sidebar" :id="'menu-item-' + menuIndex + '-' + index"
            v-for="(sidemenu, index) in sidebar.subMenu" @click="selectTab('#menu-item-' + menuIndex + '-' + index,)">
            <router-link :to="sidemenu.path || { name: sidemenu.component }">
              <em class="menu-livicon" :data-icon="sidemenu.iconClass"></em><span class="menu-title wordStyle "
                data-i18n="Invites">{{ $t(sidemenu.name) }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import sidedata from './sideMenu'
export default {
  name: 'Sidebar',
  data() {
    return {
      sidebarIcon: require('@/assets/collapse.svg').default,
      sidebarReverseIcon: require('@/assets/collapse1.svg').default,
      toggleExpand: true,
      userData: "",
      sideDropdownData: sidedata,
      sideMenus: [],
      isDropdown: false,
      menuTitle: '',
      subMenu: '',
      sidebarEnterpriseArray: [],
      sidebarPactoArray: [],
      pactoSidebarArray: [],
      sidebarArray: [],
      selectedMenu: 'pacto',
      enterpriseTab: false,
      currentUrl: '',
      enterprisecolor: false
    }
  },
  mounted() {
    this.loadingSidebar()
    this.getPactoData()
    this.navigation()
    document.addEventListener('click', this.close)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
  },
  watch: {
    $route(to, from) {
      this.isDropdown = false;
    }
  },

  methods: {
    navigation() {
      /** Handle Details Pages */
      const uri = location.href;
      if (uri.includes('contracts/proposals/')) {
        $('#proposal-navbar-item').addClass('active');
      } else if (uri.includes('contracts/details/')) {
        $('#contracts-navbar-item').addClass('active');
      }
      /** Handle Page Refresh */
      $("li.nav-item-sidebar > a").each(function () {
        if ($(this).hasClass("active")) {
          $(this).parents("li.nav-item-sidebar").addClass("active")
        }
      })
      /** Active State */
    },
    selectTab(targetId) {
      let $targetIcon = $(targetId).find(".menu-livicon")
      $("li.nav-item-sidebar").removeClass("active-collapse")
      $("li.nav-item-sidebar").removeClass("active")
      $(targetId).addClass("active")
    },
    iconStyle() {
      $.each($('.menu-livicon'), function (i) {
        var $this = $(this),
          icon = $this.data('icon'),
          iconStyle = $('#main-menu-navigation').data("icon-style");

        $this.addLiviconEvo({
          name: icon,
          style: iconStyle,
          duration: 0.85,
          strokeWidth: '1.3px',
          eventOn: 'parent',
          strokeColor: menuIconColorsObj.iconStrokeColor,
          solidColor: menuIconColorsObj.iconSolidColor,
          fillColor: menuIconColorsObj.iconFillColor,
          strokeColorAlt: menuIconColorsObj.iconStrokeColorAlt,
          afterAdd: function () {
            if (i === $(".main-menu-content .menu-livicon").length - 1) {
              // When hover over any menu item, start animation and stop all other animation
              $(".main-menu-content .nav-item a").on("mouseenter", function () {
                if ($(".main-menu-content .menu-livicon").length) {
                  $(".main-menu-content .menu-livicon").stopLiviconEvo()
                  $(this)
                    .find(".menu-livicon")
                    .playLiviconEvo()
                }
              })
            }
          }
        });
      });
    },

    close(e) {
      let dropdown = this.$refs.dropdownMenu
      if (dropdown && !dropdown.contains(e.target) && !this.$refs.navbarHeader.contains(e.target)) {
        this.isDropdown = false
      }
    },

    switchingSidebar(id, url) {
      let self = this;
      if (id == 'enterprise') {
        self.enterpriseTab = true;
      }
      self.isDropdown = false;
      self.selectedMenu = id
      this.$router.push({ path: url })
      self.getPactoData()
      setTimeout(self.iconStyle, 300)
    },
    loadingSidebar() {
      let self = this;
      self.currentUrl = window.location.href;
      if (/enterprise/g.test(self.currentUrl)) {
        self.enterpriseTab = true;
        self.enterprisecolor = true;
        self.selectedMenu = 'enterprise'
      } else {
        self.enterpriseTab = false;
        self.enterprisecolor = false
        self.selectedMenu = 'pacto'
      }
    },
    getMenuData() {
      let self = this;
      self.sidebarArray = []
      self.sidebarEnterpriseArray = self.sideDropdownData.enterprise;
      self.sidebarEnterpriseArray.menuItems.forEach((item) => {
        let sidebarObj = {
          title: item.title,
          subMenu: item.subMenu
        }
        self.sidebarArray.push(sidebarObj)
      })
    },
    getPactoData() {
      let self = this;
      self.sidebarArray = []
      self.sidebarPactoArray = self.sideDropdownData[self.selectedMenu];
      self.sidebarPactoArray.menuItems.forEach((item) => {
        let sidebarObj = {
          title: item.title,
          subMenu: item.subMenu
        }
        self.sidebarArray.push(sidebarObj)
      })
    },

    dropdownEnable() {
      let self = this;
      self.sideMenus = self.sideDropdownData.topMenu
      if (self.sideMenus.length > 1) {
        self.isDropdown = true
      } else {
        self.isDropdown = false
      }
    },
    toggleSidebar() {
      let self = this;
      self.toggleExpand = !self.toggleExpand;
    },
    dropdownDisable() {
      let self = this;
      self.isDropdown = false
    },
  }
}
</script>
<style>
.wordStyle {
  word-break: break-word;
}

.pStyleAlignment {
  transform: translate(1px, -13px);
}

.alignSpan {
  margin-top: -1em;
  margin-left: 23px;
}

.toggleDiv {
  width: 6em;
  height: 5em;
  position: absolute;
  top: 15px;
  z-index: 1032;
}

.toggleDivShrink {
  left: 45px;
}

.toggleDivExpand {
  left: 263px;
}

.titleStyle {
  font-size: 18px;
  font-weight: 500;
  color: #767677;
}

.iconStyle {
  display: flex;
  position: relative;
  left: -10px;
  top: -12px;
}

.liHighlight {
  background: #4A0A1E21;
  color: #4A0A1E;
  border-radius: 0.267rem
}

.liNoHilight {
  color: #727E8C;
  background: #F2F4F4;
  border: #DFE3E7;
}

.switchDiv {
  width: 25em;
  height: 7em;
  position: fixed;
  top: 52px;
  left: 7px;
  z-index: 10000;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  background: #FFFFFF;
  cursor: pointer;
}

.wordStyle {
  width: 200px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: break-spaces;
}

.headingStyle {
  font-size: 16px !important;
  color: #94979B !important;
  font-weight: 400 !important;
}
</style>
